import { render, staticRenderFns } from "./sponsor_expo_add.vue?vue&type=template&id=86906e6a&scoped=true&"
import script from "./sponsor_expo_add.vue?vue&type=script&lang=js&"
export * from "./sponsor_expo_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86906e6a",
  null
  
)

export default component.exports